import { getTimeMillisApi } from '@/api/system'
import platformSetting from '@/setting'

const state = {
  systemTime: '', // 系统时间
  consumerHotline: '400-8566-100', // 客户服务热线
  domain: '' // 网站域名
}
const mutations = {
  SET_SYSTEM_TIME: (state, time) => {
    state.systemTime = time
  },

  SET_SYSTEM_DOMAIN: (state, domain) => {
    state.domain = domain
  }
}

const getters = {
  // 平台配置
  platformConfig(state) {
    return (
      platformSetting.find(value => value.domain.includes(state.domain)) ||
      platformSetting[0]
    )
  }
}

const actions = {
  /**
   * 获取系统时间（不精确）
   * @param commit
   * @param axios
   * @returns {Promise<unknown>}
   */
  getSystemTime({ commit }, axios) {
    return new Promise((resolve, reject) => {
      getTimeMillisApi(axios)
        .then(res => {
          commit('SET_SYSTEM_TIME', res.data || '')
          resolve()
        })
        .catch(() => {
          commit('SET_SYSTEM_TIME', Date.now())
          resolve()
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
